import { defineMessages } from 'react-intl'

const scope = `procurify.components.DataTable.BudgetAccountCodeCell`

export default defineMessages({
  multipleLabel: {
    id: `${scope}.multipleLabel`,
    defaultMessage: 'Multiple',
  },
})
